import { useMutation, useQueryClient } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useRemoveCustomOffset() {
  const queryClient = useQueryClient()
  return useMutation((id: string) => ApiService.CustomOffsets.removeCustomOffset(id), {
    onSuccess: () =>
      ['confirmation', 'reminder', 'follow_up'].forEach((messageType) => {
        queryClient.invalidateQueries(['custom-offsets', messageType])
      }),
  })
}
